import React from 'react';
import { FunctionComponent } from 'react';
import { Modal } from 'rs-emd-ui-atoms';
import styles from './product-info-modal-component.module.scss';

type ProductInfoModalProps = {
  title?: string | null;
  message?: string | null;
  closeCallback: () => void;
};

export const ProductInfoModal: FunctionComponent<ProductInfoModalProps> = (props: ProductInfoModalProps) => {
  return (
    <Modal
      className={styles['product-info-modal']}
      headerElt={<p className={styles.title}>{props.title}</p>}
      closeCallback={props.closeCallback}>
      <div className={styles.content} dangerouslySetInnerHTML={{ __html: props.message ?? '' }}></div>
    </Modal>
  );
};
